export default {
  en: {
    'conversion-tool.mapping-conversion-modal.title': 'Choose sheets to convert',
    'conversion-tool.mapping-conversion-modal.convert': 'Convert',
    'conversion-tool.mapping-conversion-modal.mapping-settings': 'Mapping Settings',
    'conversion-tool.mapping-conversion-modal.new-mapping': 'New mapping',
    'conversion-tool.mapping-conversion-modal.select-mapping': 'Select mapping',
  },
};
